import React, { useState } from "react";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import LoginPage from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/Admin";
import "./App.css";

const ADMIN_EMAIL = "anbunathan.r@gmail.com";

function AppContent() {
  const { user, loading } = useAuth();
  const [view, setView] = useState("dashboard"); // "dashboard" | "admin"

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0d1117" }}>
        <span style={{ color: "#8b949e", fontSize: 14 }}>Loading...</span>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  const isAdmin = user.email === ADMIN_EMAIL;

  return (
    <div>
      {isAdmin && (
        <div style={{ background: "#161b22", borderBottom: "1px solid #30363d", padding: "6px 20px", display: "flex", gap: 8, alignItems: "center" }}>
          <span style={{ color: "#8b949e", fontSize: 12, marginRight: 8 }}>Admin:</span>
          <button
            onClick={() => setView("dashboard")}
            style={{ padding: "4px 14px", background: view === "dashboard" ? "#1f6feb22" : "transparent",
              border: `1px solid ${view === "dashboard" ? "#1f6feb" : "#30363d"}`,
              borderRadius: 6, color: view === "dashboard" ? "#58a6ff" : "#8b949e", cursor: "pointer", fontSize: 12 }}>
            📋 My Dashboard
          </button>
          <button
            onClick={() => setView("admin")}
            style={{ padding: "4px 14px", background: view === "admin" ? "#FF990022" : "transparent",
              border: `1px solid ${view === "admin" ? "#FF9900" : "#30363d"}`,
              borderRadius: 6, color: view === "admin" ? "#FF9900" : "#8b949e", cursor: "pointer", fontSize: 12 }}>
            👥 Admin Panel
          </button>
        </div>
      )}
      {view === "admin" && isAdmin ? <AdminDashboard /> : <Dashboard />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
